/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryDetailsViewModel } from './IntermediaryDetailsViewModel';
import {
    IntermediaryDetailsViewModelFromJSON,
    IntermediaryDetailsViewModelFromJSONTyped,
    IntermediaryDetailsViewModelToJSON,
} from './IntermediaryDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfIntermediaryDetailsViewModel
 */
export interface ResultOfIntermediaryDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {IntermediaryDetailsViewModel}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    data?: IntermediaryDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfIntermediaryDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfIntermediaryDetailsViewModel interface.
 */
export function instanceOfResultOfIntermediaryDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfIntermediaryDetailsViewModelFromJSON(json: any): ResultOfIntermediaryDetailsViewModel {
    return ResultOfIntermediaryDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfIntermediaryDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfIntermediaryDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : IntermediaryDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfIntermediaryDetailsViewModelToJSON(value?: ResultOfIntermediaryDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': IntermediaryDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

